import { type ReactNode } from 'react'

import { LoadingMask } from '@/components/common/LoadingMask'
import { Icon } from '@/components/icons/Icon'
import { type BrandType } from '@/defs/brand'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import { ButtonRoot, type Props as RootProps } from '../ButtonRoot/ButtonRoot'

import styles from './ButtonDefault.module.scss'

type Props = {
  centered?: boolean
  children: ReactNode
  colorScheme?:
    | 'selected'
    | 'content'
    | 'light'
    | 'dark'
    | 'surface'
    | 'subtle'
    | 'muted'
    | 'warning'
    | 'alert'
    | 'success'
    | 'patreon'
    | BrandType
  disabled?: boolean
  fontNormal?: boolean
  hover?: 'none'
  justifyContent?: 'left' | 'right' | 'center'
  loading?: boolean
  maxwidth?: boolean
  padding?: 'none'
  shadow?: 'none'
  showLoadingMask?: boolean
  size?: 'xs' | 'sm' | 'lg'
  textshadow?: boolean
  variant?: 'outline' | 'cardFiltersButton' | 'group'
  whitespace?: 'wrap'
} & DistributiveOmit<RootProps, 'className'>

export const ButtonDefault = ({
  centered,
  children,
  colorScheme,
  fontNormal,
  hover,
  justifyContent,
  loading,
  maxwidth,
  padding,
  shadow,
  showLoadingMask,
  size,
  textshadow,
  variant,
  whitespace,
  ...props
}: Props) => (
  <ButtonRoot
    aria-busy={loading || undefined}
    className={cn(styles.container, {
      centered,
      colorScheme,
      disabled: props.disabled || loading,
      fontNormal,
      hover,
      justifyContent,
      loading,
      maxwidth,
      padding,
      shadow,
      size,
      styles,
      textshadow,
      variant,
      whitespace,
    })}
    {...props}
  >
    <span className={styles.label}>{children}</span>
    {loading && (
      <span className={styles.iconLoading}>
        <Icon name='spinner' />
      </span>
    )}
    {showLoadingMask !== undefined && <LoadingMask loading={showLoadingMask} />}
  </ButtonRoot>
)
